<template>
  <div v-if="lastAccessTimestamp">
    <!-- Desktop Version -->
    <div v-if="isInDrawer" class="last-access-info">
      <div>{{ $tf('LastConnectionAt') }} {{ formattedTimestamp }}</div>
      <div class="mt-2">
        {{ $tf('RememberSecurityPolicy') }}
      </div>
      <div class="mt-2">
        <router-link :to="{ path: '/myaccount', query: { open: 'last-access' } }" class="text-primary">
          {{ $tf('GoToMyAccount') }}
        </router-link>
      </div>
    </div>

    <!-- Mobile Version -->
    <div v-else-if="$vuetify.breakpoint.smAndDown && !mobileShown" class="mobile-access-info">
        <div class="mobile-access-line">
            <router-link :to="{ path: '/myaccount', query: { open: 'last-access' } }" class="icon-link">
            <i class="material-icons">manage_accounts</i>
            </router-link>
            <div>
            <div>{{ $tf('LastConnectionAt') }} {{ mobileFormattedDate }}</div>
            <div class="security-policy-text">{{ $tf('RememberSecurityPolicy') }}</div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
    export default {
      name: 'LastAccessInfo',
      props: {
        isInDrawer: {
          type: Boolean,
          default: false
        }
      },
      data () {
        return {
          lastAccessTimestamp: null,
          mobileShown: localStorage.getItem('mobileAccessShown') === 'true'
        }
      },
      mounted () {
        this.loadLastAccess()
      },
      computed: {
        formattedTimestamp () {
          return this.$moment(this.lastAccessTimestamp * 1000).format('LLL')
        },
        mobileFormattedDate () {
          const momentDate = this.$moment(this.lastAccessTimestamp * 1000)
          const today = this.$moment().startOf('day')
          if (momentDate.isSame(today, 'day')) {
            return `${this.$tf('Today')} ${momentDate.format('HH:mm')}`
          } else {
            return `${this.$tf('LastConnectionAt')} ${momentDate.format('DD/MM/YY HH:mm')}`
          }
        }
      },
      methods: {
        async loadLastAccess () {
          try {
            const response = await this.$services.user.accesses({
              params: { page: 1, count: 1, 'sort[]': '-timestamp' }
            })

            if (response.status === 200 && response.body.results.length) {
              this.lastAccessTimestamp = response.body.results[0].timestamp
            }

            if (this.$vuetify.breakpoint.smAndDown && !this.mobileShown) {
              setTimeout(() => {
                this.mobileShown = true
                localStorage.setItem('mobileAccessShown', 'true')
              }, 30000)
            }
          } catch (e) {
            console.error('Failed to fetch last access timestamp', e)
          }
        }
      }
    }
</script>

<style scoped>
    .last-access-info {
        font-size: 0.875rem;
        color: rgba(0, 0, 0, 0.38);
        font-family: Roboto, sans-serif;
        line-height: 1.6;
        padding: 0 20px 20px;
        margin-top: 5px;
        text-align: center;
    }

    .mobile-access-info {
        font-size: 0.8rem;
        text-align: left;
        line-height: 1.2;
        position: fixed;
        bottom: 8px;
        transform: translateY(0);
        transition: transform 0.3s ease-in-out;
        left: 12px;
        color: rgba(0, 0, 0, 0.38);
        background: #fff;
        padding: 4px 8px;
        border-radius: 4px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        z-index: 9999;
    }

    .mobile-access-info.footer-visible {
      transform: translateY(-42px);
      transition: transform 0.3s ease-in-out;
    }

    @media only screen and (max-width: 600px) {
      .mobile-access-info.footer-visible {
        transform: translateY(-64px) !important;
        transition: transform 0.3s ease-in-out;
      }
    }

    .mobile-access-line {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        line-height: 1.2;
    }

   .security-policy-text {
        margin-top: 2px;
        line-height: 1.2;
    }

    .icon-link {
        display: inline-block;
        padding: 8px;
        z-index: 10;
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/LastAccessInfo.vue